<section>
  <img src="../../../../assets/svg/warning.svg" alt="Imagem de atenção" />
  <h2>A chave Pix expirou</h2>
  <p>Gere uma nova chave Pix ou selecione outra forma de pagamento.</p>
  <app-primary-button class="w-100" [block]="true" (click)="reload()">Ok </app-primary-button>
</section>
